import { useState } from "react";
import { Loader2, Lock } from "lucide-react";
import { adminLogin, setToken } from "@/lib/adminApi";
import { Input } from "@/components/ui/input";

const formatError = (detail) => {
  if (!detail) return "Er ging iets mis. Probeer opnieuw.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").join(" ");
  return String(detail);
};

const AdminLogin = ({ onSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { token, user } = await adminLogin(email.trim(), password);
      setToken(token);
      onSuccess(user);
    } catch (err) {
      setError(formatError(err.response?.data?.detail) || err.message);
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0a2540] px-4" data-testid="admin-login-page">
      <div className="w-full max-w-sm rounded-2xl bg-white p-8 shadow-2xl">
        <div className="mb-6 flex flex-col items-center text-center">
          <div className="mb-3 grid h-12 w-12 place-items-center rounded-full bg-[#0a5a3c]">
            <Lock className="h-5 w-5 text-white" />
          </div>
          <img src="/logo_aponiqo_dark.png" alt="aponiqo" className="h-7 w-auto" />
          <p className="mt-2 text-sm font-semibold text-[#0a2540]">Admin</p>
          <p className="mt-1 text-sm text-slate-500">Log in om je bestellingen te beheren</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="mb-1 block text-xs font-medium text-slate-600">E-mail</label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              required data-testid="admin-email-input" autoComplete="username" />
          </div>
          <div>
            <label className="mb-1 block text-xs font-medium text-slate-600">Wachtwoord</label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              required data-testid="admin-password-input" autoComplete="current-password" />
          </div>
          {error && <p className="text-sm font-medium text-red-600" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="flex w-full items-center justify-center gap-2 rounded-lg bg-[#0a5a3c] py-3 font-semibold text-white transition-colors hover:bg-[#0a4a30] disabled:opacity-60">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Inloggen"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
